module.exports = __webpack_public_path__ + "static/media/reports_internal-transfer.50780e76.svg";